<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'TITLE'">
    <h1 [ngClass]="['title', class]">{{ text }}</h1>
  </ng-container>
  <ng-container *ngSwitchCase="'PAGE-TITLE'">
    <h2 [ngClass]="['page-title', class]" role="heading" aria-level="2">{{ text }}</h2>
  </ng-container>
  <ng-container *ngSwitchCase="'PAGE-DESCRIPTION'">
    <h3 [ngClass]="['page-description', class]" role="heading" aria-level="3" [innerHTML]="text">{{ text }}</h3>
  </ng-container>
  <ng-container *ngSwitchCase="'SECTION-TITLE'">
    <h3 [ngClass]="['card-title', class]" role="heading" aria-level="3">{{ text }}</h3>
  </ng-container>
  <ng-container *ngSwitchCase="'CARD-TITLE'">
    <h3 [ngClass]="['card-title', class]" role="heading" aria-level="3">{{ text }}</h3>
  </ng-container>
  <ng-container *ngSwitchCase="'CARD-DESCRIPTION'">
    <h4 [ngClass]="['card-description', class]" role="heading" aria-level="4">{{ text }}</h4>
  </ng-container>
  <ng-container *ngSwitchCase="'TEXT'">
    <p [ngClass]="['text', class]" role="paragraph">{{ text }}</p>
  </ng-container>
  <ng-container *ngSwitchCase="'SMALL'">
    <small [ngClass]="['small-text', class]" role="contentinfo">{{ text }}</small>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <p [ngClass]="['default', class]" role="paragraph">{{ text }}</p>
  </ng-container>
</ng-container>
